import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../icons/Icon.js";
import { cx } from "../lib/cx.js";
const icons = {
    neutral: "info",
    success: "success",
    warning: "warning",
    danger: "alert",
    info: "info",
};
export function Alert({ tone = "neutral", title, children, className, ...rest }) {
    const role = tone === "danger" || tone === "warning" ? "alert" : "status";
    return (_jsxs("div", { className: cx("evolua-alert", `evolua-alert--${tone}`, className), role: role, ...rest, children: [_jsx(Icon, { name: icons[tone], size: 18 }), _jsxs("div", { children: [title ? _jsx("p", { className: "evolua-alert__title", children: title }) : null, _jsx("div", { className: "evolua-alert__body", children: children })] })] }));
}
export function ContextBanner({ tone = "privileged", children, action, className, ...rest }) {
    return (_jsxs("div", { className: cx("evolua-ctx", `evolua-ctx--${tone}`, className), role: "status", "aria-live": "polite", ...rest, children: [_jsx("span", { children: children }), action] }));
}
//# sourceMappingURL=Alert.js.map